var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"preview"},[(_vm.value)?_c('img',{attrs:{"src":_vm.value,"alt":""}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }